"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = __importDefault(require("./styles"));
const Frame = ({ body, buttons, header }) => {
    const classes = styles_1.default();
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement("div", { className: header.className || 'header' },
            react_1.default.createElement("div", { className: "logo" }, header.logo)),
        react_1.default.createElement("div", { className: body.className || 'body' }, body.children),
        react_1.default.createElement("div", { className: buttons.className || 'buttons' }, buttons.children)));
};
exports.default = Frame;
